import { BrowserCrypto } from "@azure/msal-browser/dist/crypto/BrowserCrypto";
import { PkceGenerator } from "@azure/msal-browser/dist/crypto/PkceGenerator";
import { Logger } from "@azure/msal-browser";

const crypto = new BrowserCrypto(new Logger({}));
const pkceGenerator = new PkceGenerator(crypto);

export const generateChallenge = async () => pkceGenerator.generateCodes();
